export const HIDDEN_AMOUNT = '*****'

export default {
  bind (el, binding, vnode) {
    const store = vnode.context.$store
    el['data-base-value'] = el.innerHTML
    if (store.state.privateModeAdvisory) {
      el.innerHTML = HIDDEN_AMOUNT
    }
    el['data-store-private-subscription'] = store.watch(({ privateModeAdvisory }) => privateModeAdvisory, (privateModeAdvisory) => {
      if (store.state.privateModeAdvisory) {
        el.innerHTML = HIDDEN_AMOUNT
      } else {
        el.innerHTML = el['data-base-value']
      }
    })
  },

  componentUpdated (el, binding, vnode) {
    const store = vnode.context.$store

    if (el.innerHTML !== HIDDEN_AMOUNT && el.innerHTML !== el['data-base-value']) {
      el['data-base-value'] = el.innerHTML
      if (store.state.privateModeAdvisory) {
        el.innerHTML = HIDDEN_AMOUNT
      }
    }
  },

  unbind (el) {
    el['data-store-private-subscription'] && el['data-store-private-subscription']()
  }
}
